module.exports = __webpack_public_path__ + "static/church-group-photo-4a117142d3b1cb355e7e8caa67e80209.jpg";